import { env } from "@/config/env";

export const features = {
  training: true,
  onboarding: true,
  recruiting: true,
  recruiting_v2: true,
  sales: false,
  crm: false,
  blitz_postings: true,
  calendar_reliability_v2: env.features.calendarReliabilityV2,
  will_onboarding: env.features.willOnboarding,
  leadership_dashboard: env.features.leadershipDashboard,
  performance_center: env.features.performanceCenter,
  hierarchical_dashboard: env.features.hierarchicalDashboard,
  multiTenancy: env.features.multiTenancy,
};

export type FeatureFlag = keyof typeof features;

export const isFeatureEnabled = (flag: FeatureFlag): boolean => features[flag];

export const isRecruitingV2Enabled = (): boolean => features.recruiting_v2;
